import { RefreshCw } from 'lucide-react';
import { cn } from '@/lib/utils';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/Tooltip.tsx';
import useRecalculateClientBalance from '@/features/dashboard/balances/hooks/useRecalculateClientBalance.ts';

/** Klient i rezerwacja są 1:1, więc przeliczenie salda klienta przelicza tę rezerwację. */
const RecalculateBalanceButton = ({ clientId }: { clientId: string }) => {
  const recalculate = useRecalculateClientBalance(clientId);

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="inline-flex">
          <ActionButton
            tone="ghost"
            size="xs"
            iconOnly
            aria-label="Przelicz saldo"
            disabled={recalculate.isPending}
            onClick={() => recalculate.mutate()}
          >
            <RefreshCw
              aria-hidden
              className={cn(recalculate.isPending && 'animate-spin')}
            />
          </ActionButton>
        </span>
      </TooltipTrigger>
      <TooltipContent>Przelicz saldo</TooltipContent>
    </Tooltip>
  );
};

export default RecalculateBalanceButton;
